<template>
  <div class="item">
    <el-row :gutter="10">
      <el-col :span="12">
        <p class="history-text">{{ name }}</p>
      </el-col>
      <el-col :span="12">
        <p class="history-text text-right">
          {{ numberWithCommas(points) }} <span class="text-point">{{ $t('components.history.point') }}</span>
        </p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <p class="history-text text-sub">
          {{ points > 0 ? $t('components.history.add-points') : $t('components.history.reduce-points') }}
        </p>
      </el-col>
      <el-col :span="12">
        <p class="history-text text-sub text-right">{{ time }}</p>
      </el-col>
    </el-row>
    <el-divider class="custom-divider"></el-divider>
  </div>
</template>

<script>
import mixins from "@/helper/mixins";

export default {
  name: "HistoryItem",
  mixins: [mixins],
  props: {
    name: {
      type: String,
      default: "N/A",
    },
    points: {
      type: Number,
      default: 0,
    },
    time: {
      type: String,
      default: "N/A",
    },
  },
};
</script>

<style scoped>
.history-text {
  color: var(--gray-2);
  margin: 0;
  line-height: 24px;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0em;
}
.text-right {
  text-align: right;
}
.text-left {
  text-align: left;
}
.text-point {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0em;
  text-align: right;
}
.text-sub {
  color: var(--gray-4);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
}
.custom-divider {
  margin-block: 8px;
}
</style>